import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import KakaoFloatingButton from './pages/home/components/KakaoFloatingButton';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
      <KakaoFloatingButton />
    </BrowserRouter>
  );
}

export default App;